import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

const index = ({ value, className, disabled, id, name, onChange, help, design, mandatory }) => {

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Tooltip title={help} placement="top">
      <FormControlLabel className={className ?? undefined} key={id}
        sx={{
          flexDirection: 'row'
        }}
        control={<Checkbox checked={value} id={id} />}
        disabled={disabled}
        label={
          <span style={{ fontWeight: '600', fontSize: 'inherit', lineHeight: 'inherit' }}>
            {design !== 'table' ? <span>{name} {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}</span> : null}
          </span>
        }
        value={value}
        onChange={handleChange}
      />
    </Tooltip>
  )
}

export default index